(ns app.strive-forms.question-fields.welcome-screen
  (:require [app.strive-forms.component-multi-methods :refer [show-action-btn?]]
            [app.strive-forms.helper-functions :refer [enable-continue-button]]
            [reagent.core :as r]))

(defmethod show-action-btn? "welcome_screen" [_]
  true)

(defn welcome-screen [{:keys [field-id field input-data button-ids-for-button]}]
  (let [text-val (r/atom (:value (get input-data (keyword field-id))))]
    (fn [{:keys [theme-data form-messages button-ids-for-button]}] 
(when-not (and (nil? (:additional_settings field)) (nil? (:question_image (:additional_settings field))))
  [:img {:src (:question_image (:additional_settings field))
         :alt "welcome_screen_img"
         :fetchpriority "high"
         :width "50%"
         :height "100%"
         :loading "eager"
         }])
      )))
